const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const STATIC_BASE_URL = process.env.REACT_APP_STATIC_URL;


// API_BASE_URL should be e.g. https://sikompeacenet.org/backend or https://sikompeacenet.org/backend/api
// If it ends with /api, use /contact.php, /sliders.php etc. Otherwise use /api/contact.php, etc.
const apiPath = (path) => {
  const base = (API_BASE_URL || '').replace(/\/$/, '');
  const hasApi = base.endsWith('/api');
  return hasApi ? `${base}/${path}` : `${base}/api/${path}`;
};
export const API_ENDPOINTS = {
  HOME: apiPath('home.php'),
  PAGES: `${API_BASE_URL}/pages.php`,
  THEMATIC_AREAS: `${API_BASE_URL}/thematic-areas.php`,
  PROJECTS: `${API_BASE_URL}/projects.php`,
  TEAM: `${API_BASE_URL}/team.php`,
  UPDATES: `${API_BASE_URL}/updates.php`,
  PARTNERS: `${API_BASE_URL}/partners.php`,
  OPPORTUNITIES: `${API_BASE_URL}/opportunities.php`,
  CONTACT: apiPath('contact.php'),
  SETTINGS: `${API_BASE_URL}/settings.php`,
  HERO_IMAGES: apiPath('sliders.php'),
  STATS: `${API_BASE_URL}/settings.php`,
  ABOUT_SECTIONS: `${API_BASE_URL}/settings.php`
};

export default API_BASE_URL;